import React from 'react'
import { getImages } from '../const'
import InstagramFeed from './InstagramFeed'
import UseScrollReveal from '../Common/UseScrollReveal '

const JoinMclearn = () => {
    UseScrollReveal();
    return (
        <>
            <section className='join-mclearn-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6 jm-left'>
                            {/* <div className='row'>
                                <div className='col-md-4 col-4 wow fadeIn' data-wow-delay='0.2s'>
                                    <div className='jm-image'>
                                        <img src={getImages('car-1.png')} alt='car' />
                                    </div>
                                </div>
                                <div className='col-md-4 col-4 wow fadeIn' data-wow-delay='0.3s'>
                                    <div className='jm-image'>
                                        <img src={getImages('car-2.png')} alt='car' />
                                    </div>
                                </div>
                                <div className='col-md-4 col-4 wow fadeIn' data-wow-delay='0.4s'>
                                    <div className='jm-image'>
                                        <img src={getImages('car-3.png')} alt='car' />
                                    </div>
                                </div>
                                <div className='col-md-4 col-4 wow fadeIn' data-wow-delay='0.5s'>
                                    <div className='jm-image'>
                                        <img src={getImages('car-4.png')} alt='car' />
                                    </div>
                                </div>
                                <div className='col-md-4 col-4 wow fadeIn' data-wow-delay='0.6s'>
                                    <div className='jm-image'>
                                        <img src={getImages('car-5.png')} alt='car' />
                                    </div>
                                </div>
                                <div className='col-md-4 col-4 wow fadeIn' data-wow-delay='0.7s'>
                                    <div className='jm-image'>
                                        <img src={getImages('car-6.png')} alt='car' />
                                    </div>
                                </div>
                                <div className='col-md-4 col-4 wow fadeIn' data-wow-delay='0.8s'>
                                    <div className='jm-image'>
                                        <img src={getImages('car-7.png')} alt='car' />
                                    </div>
                                </div>
                                <div className='col-md-4 col-4 wow fadeIn' data-wow-delay='0.9s'>
                                    <div className='jm-image'>
                                        <img src={getImages('car-8.png')} alt='car' />
                                    </div>
                                </div>
                                <div className='col-md-4 col-4 wow fadeIn' data-wow-delay='1s'>
                                    <div className='jm-image'>
                                        <img src={getImages('car-9.png')} alt='car' />
                                    </div>
                                </div>
                            </div> */}
                            <InstagramFeed/>
                        </div>
                        <div className='col-md-6 jm-right text-center d-flex align-items-center'>
                            <div className='w-100'>
                                <img className='reveal wow fadeIn' src={getImages('mclaren-orlando-logo-white.png')} alt='logo' />
                                <h2 className="jm-title text-uppercase reveal wow fadeIn">Join the McLaren <br />Orlando Community</h2>
                                <div className='sm-title mb-1 reveal wow fadeIn'>Follow us on Instagram</div>
                                <div className='sm-title font-1-2em fw-700 reveal wow fadeIn'>@mclarenorlando</div>
                                <div className='mt-80 reveal wow fadeIn'>
                                    <a href='https://www.instagram.com/mclarenorlando/' target='_blank' className='theme-btn text-uppercase d-inline-block'>Follow Us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default JoinMclearn